/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Latestbadge1Inputs */

const id_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`terbaru`)
};

const ms_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`terkini`)
};

const da_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seneste`)
};

const de_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`letzte`)
};

const en_us2_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`latest`)
};

const es_es2_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`más reciente`)
};

const es_mx2_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`más reciente`)
};

const fil_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pinakabago`)
};

const fr_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dernier`)
};

const it_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`più recente`)
};

const hu_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`legutóbbi`)
};

const nl_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meest recent`)
};

const no_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`siste`)
};

const pl_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`najnowsze`)
};

const pt_br2_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mais recente`)
};

const pt_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mais recente`)
};

const ro_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cele mai recente`)
};

const fi_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`viimeisin`)
};

const sv_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`senaste`)
};

const vi_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mới nhất`)
};

const tr_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en yeni`)
};

const cs_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nejnovější`)
};

const bg_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`най-нов`)
};

const ru_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`последняя`)
};

const uk_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`найновіше`)
};

const ar_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأحدث`)
};

const hi_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम`)
};

const th_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล่าสุด`)
};

const ja_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新`)
};

const zh_cn2_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新`)
};

const zh_hant1_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新`)
};

const ko_sandboxes_latestbadge1 = /** @type {(inputs: Sandboxes_Latestbadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최신`)
};

/**
* | output |
* | --- |
* | "latest" |
*
* @param {Sandboxes_Latestbadge1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_latestbadge1 = /** @type {((inputs?: Sandboxes_Latestbadge1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Latestbadge1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_latestbadge1(inputs)
	if (locale === "ms") return ms_sandboxes_latestbadge1(inputs)
	if (locale === "da") return da_sandboxes_latestbadge1(inputs)
	if (locale === "de") return de_sandboxes_latestbadge1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_latestbadge1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_latestbadge1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_latestbadge1(inputs)
	if (locale === "fil") return fil_sandboxes_latestbadge1(inputs)
	if (locale === "fr") return fr_sandboxes_latestbadge1(inputs)
	if (locale === "it") return it_sandboxes_latestbadge1(inputs)
	if (locale === "hu") return hu_sandboxes_latestbadge1(inputs)
	if (locale === "nl") return nl_sandboxes_latestbadge1(inputs)
	if (locale === "no") return no_sandboxes_latestbadge1(inputs)
	if (locale === "pl") return pl_sandboxes_latestbadge1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_latestbadge1(inputs)
	if (locale === "pt") return pt_sandboxes_latestbadge1(inputs)
	if (locale === "ro") return ro_sandboxes_latestbadge1(inputs)
	if (locale === "fi") return fi_sandboxes_latestbadge1(inputs)
	if (locale === "sv") return sv_sandboxes_latestbadge1(inputs)
	if (locale === "vi") return vi_sandboxes_latestbadge1(inputs)
	if (locale === "tr") return tr_sandboxes_latestbadge1(inputs)
	if (locale === "cs") return cs_sandboxes_latestbadge1(inputs)
	if (locale === "bg") return bg_sandboxes_latestbadge1(inputs)
	if (locale === "ru") return ru_sandboxes_latestbadge1(inputs)
	if (locale === "uk") return uk_sandboxes_latestbadge1(inputs)
	if (locale === "ar") return ar_sandboxes_latestbadge1(inputs)
	if (locale === "hi") return hi_sandboxes_latestbadge1(inputs)
	if (locale === "th") return th_sandboxes_latestbadge1(inputs)
	if (locale === "ja") return ja_sandboxes_latestbadge1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_latestbadge1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_latestbadge1(inputs)
	return ko_sandboxes_latestbadge1(inputs)
});
export { sandboxes_latestbadge1 as "sandboxes.latestBadge" }